import { useMemo } from "react";
import { getLocale, useIntl, useSelector } from "umi";

export const useD2D3D7Text= (dataFrameVal?:string) => {
  const { formatMessage } = useIntl();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const data_frame = dataFrameVal ? dataFrameVal :useSelector((state: any) => state?.dashboard?.currentGame?.data_frame || 'mobile');
  const isEn = getLocale() === 'en-US';
  const d2d3d7Obj: any = useMemo(() => ({
    mobile: {
      d2CardTitle: formatMessage({ id: 'realtime_users_d2_card_title' }),
      d3CardTitle: formatMessage({ id: 'realtime_users_d3_card_title' }),
      d7CardTitle: formatMessage({ id: 'realtime_users_d7_card_title' }),
      d2Explain: formatMessage({ id: 'realtime_metrics_card_modal_table_d2_explain' }),
      d3Explain: formatMessage({ id: 'realtime_metrics_card_modal_table_d3_explain' }),
      d7Explain: formatMessage({ id: 'realtime_metrics_card_modal_table_d7_explain' }),
      retentionD2: formatMessage({ id: 'realtime_users_d2_tab' }),
      retentionD3: formatMessage({ id: 'realtime_users_d3_tab' }),
      retentionD7: formatMessage({ id: 'realtime_users_d7_tab' }),
      retentionD2Title: formatMessage({ id: 'realtime_users_d2_title' }),
      retentionD3Title: formatMessage({ id: 'realtime_users_d3_title' }),
      retentionD7Title: formatMessage({ id: 'realtime_users_d7_title' }),
      anylysizeD2ChartTitle: formatMessage({ id: 'realtime_analysis_Title_4' }),
      anylysizeD3ChartTitle: formatMessage({ id: 'realtime_analysis_Title_5' }),
      anylysizeD7ChartTitle: formatMessage({ id: 'realtime_analysis_Title_6' }),
      countryTableD2: formatMessage({ id: 'realtime_by_country_table_d2' }),
      countryTableD3: formatMessage({ id: 'realtime_by_country_table_d3' }),
      countryTableD7: formatMessage({ id: 'realtime_by_country_table_d7' }),
      anylySisD2: formatMessage({ id: 'realtime_analysis_D2' }),
      anylySisD3: formatMessage({ id: 'realtime_analysis_D3' }),
      anylySisD7: formatMessage({ id: 'realtime_analysis_D7' }),
    },
    pc: {
      d2CardTitle: formatMessage({ id: 'realtime_users_d2_card_title_pc' }),
      d3CardTitle: formatMessage({ id: 'realtime_users_d3_card_title_pc' }),
      d7CardTitle: formatMessage({ id: 'realtime_users_d7_card_title_pc' }),
      d2Explain: formatMessage({ id: 'realtime_metrics_card_modal_table_d2_explain_pc' }),
      d3Explain: formatMessage({ id: 'realtime_metrics_card_modal_table_d3_explain_pc' }),
      d7Explain: formatMessage({ id: 'realtime_metrics_card_modal_table_d7_explain_pc' }),
      retentionD2: formatMessage({ id: 'realtime_users_d2_tab_pc' }),
      retentionD3: formatMessage({ id: 'realtime_users_d3_tab_pc' }),
      retentionD7: formatMessage({ id: 'realtime_users_d7_tab_pc' }),
      retentionD2Title: formatMessage({ id: 'realtime_users_d2_title_pc' }),
      retentionD3Title: formatMessage({ id: 'realtime_users_d3_title_pc' }),
      retentionD7Title: formatMessage({ id: 'realtime_users_d7_title_pc' }),
      anylysizeD2ChartTitle: formatMessage({ id: 'realtime_analysis_Title_4_pc_base' }),
      anylysizeD3ChartTitle: formatMessage({ id: 'realtime_analysis_Title_5_pc_base' }),
      anylysizeD7ChartTitle: formatMessage({ id: 'realtime_analysis_Title_6_pc_base' }),
      countryTableD2: formatMessage({ id: 'realtime_by_country_table_d2_pc' }),
      countryTableD3: formatMessage({ id: 'realtime_by_country_table_d3_pc' }),
      countryTableD7: formatMessage({ id: 'realtime_by_country_table_d7_pc' }),
      anylySisD2: formatMessage({ id: 'realtime_analysis_D2_pc' }),
      anylySisD3: formatMessage({ id: 'realtime_analysis_D3_pc' }),
      anylySisD7: formatMessage({ id: 'realtime_analysis_D7_pc' }),
    },
    // 夜莺暂时没有留存，后续如果添加的话记得修改，但是夜莺这边挂的PC的页面，也会直接拿pc_inflexion和pc一样
    pc_inflexion: {
      d2CardTitle: formatMessage({ id: 'realtime_users_d2_card_title_pc' }),
      d3CardTitle: formatMessage({ id: 'realtime_users_d3_card_title_pc' }),
      d7CardTitle: formatMessage({ id: 'realtime_users_d7_card_title_pc' }),
      d2Explain: formatMessage({ id: 'realtime_metrics_card_modal_table_d2_explain_pc' }),
      d3Explain: formatMessage({ id: 'realtime_metrics_card_modal_table_d3_explain_pc' }),
      d7Explain: formatMessage({ id: 'realtime_metrics_card_modal_table_d7_explain_pc' }),
      retentionD2: formatMessage({ id: 'realtime_users_d2_tab_pc' }),
      retentionD3: formatMessage({ id: 'realtime_users_d3_tab_pc' }),
      retentionD7: formatMessage({ id: 'realtime_users_d7_tab_pc' }),
      retentionD2Title: formatMessage({ id: 'realtime_users_d2_title_pc' }),
      retentionD3Title: formatMessage({ id: 'realtime_users_d3_title_pc' }),
      retentionD7Title: formatMessage({ id: 'realtime_users_d7_title_pc' }),
      anylysizeD2ChartTitle: formatMessage({ id: 'realtime_analysis_Title_4_pc' }),
      anylysizeD3ChartTitle: formatMessage({ id: 'realtime_analysis_Title_5_pc' }),
      anylysizeD7ChartTitle: formatMessage({ id: 'realtime_analysis_Title_6_pc' }),
      countryTableD2: formatMessage({ id: 'realtime_by_country_table_d2_pc' }),
      countryTableD3: formatMessage({ id: 'realtime_by_country_table_d3_pc' }),
      countryTableD7: formatMessage({ id: 'realtime_by_country_table_d7_pc' }),
      anylySisD2: formatMessage({ id: 'realtime_analysis_D2_pc' }),
      anylySisD3: formatMessage({ id: 'realtime_analysis_D3_pc' }),
      anylySisD7: formatMessage({ id: 'realtime_analysis_D7_pc' }),
    },
  }), [isEn,data_frame]);

  const getD2D3D7Text = (key:string) => {
    const obj = d2d3d7Obj?.[data_frame] || d2d3d7Obj?.mobile;
    return obj?.[key] || '';
  };

  return {
    getD2D3D7Text
  };
};